module.exports = __webpack_public_path__ + "img/shiyuanhui big (6).14d77598.jpg";